import { BrowserAuthError, InteractionRequiredAuthError } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useCallback } from 'react';

/**
 * Returns a function that acquires an access token via MSAL (or from VITE_ACCESS_TOKEN env var).
 * Shared primitive used by useCallApi and the assistant chat adapter.
 */
export function useAccessToken() {
  const { accounts, instance } = useMsal();

  return useCallback(async (): Promise<string> => {
    if (import.meta.env.VITE_ACCESS_TOKEN) {
      return import.meta.env.VITE_ACCESS_TOKEN;
    }

    const msalRequest = {
      account: accounts[0],
      scopes: [`api://${import.meta.env.VITE_CLIENT_ID}/user_impersonation`],
    };

    try {
      const result = await instance.acquireTokenSilent(msalRequest);
      return result.accessToken;
    } catch (error) {
      if (
        error instanceof InteractionRequiredAuthError ||
        (error instanceof BrowserAuthError && error.errorCode === 'timed_out')
      ) {
        await instance.acquireTokenRedirect(msalRequest);
        return new Promise(() => {});
      }
      throw error;
    }
  }, [accounts, instance]);
}
